import * as dotenv from "dotenv";

dotenv.config()

console.log(process.env)

const Config: any = {
    API_URL : process.env.REACT_APP_API_URL
}

export default Config
